module.exports = __webpack_public_path__ + "static/media/confirmation.38b54362.svg";